var Handlebars, division, filter, payouts, registerHelpers, request, requestList, ui;

if (global.jQuery == null) {
  global.jQuery = require('jquery');
}

require('bootstrap/js/dropdown');

require('bootstrap/js/tab');

require('bootstrap/js/transition');

require('bootstrap/js/collapse');

Handlebars = require('hbsfy/runtime');

registerHelpers = (require('evesrp/handlebars-helpers')).registerHelpers;

registerHelpers(Handlebars);

ui = require('evesrp/common-ui');

division = require('evesrp/division');

request = require('evesrp/request');

filter = require('evesrp/filter');

requestList = require('evesrp/requestList');

payouts = require('evesrp/payouts');

if ((jQuery('#mocha')).length === 0) {
  ui.setupEvents();
  if ((jQuery('.entity-typeahead')).length !== 0) {
    division.setupEvents();
  }
  if ((jQuery('#actionMenu')).length !== 0) {
    request.setupEvents();
  }
  if ((jQuery('.filter-tokenfield')).length !== 0) {
    filter.createFilterBar('.filter-tokenfield');
  }
  if ((jQuery('table#requests')).length !== 0) {
    requestList.setupEvents();
  }
  if ((jQuery('div#requests')).length !== 0) {
    payouts.setupEvents();
  }
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2hvbWUvdGhvbWFzL0RvY3VtZW50cy9wcm9qZWN0cy9ldmVzcnAvc3JjL2V2ZXNycC9zdGF0aWMvanMvbWFpbi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvaG9tZS90aG9tYXMvRG9jdW1lbnRzL3Byb2plY3RzL2V2ZXNycC9zcmMvZXZlc3JwL3N0YXRpYy9qcy9tYWluLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxJQUFBOztBQUFBLElBQU8scUJBQVA7RUFDSSxNQUFNLENBQUMsTUFBUCxHQUFnQixPQUFBLENBQVEsUUFBUixFQURwQjs7O0FBRUEsT0FBQSxDQUFRLHVCQUFSOztBQUNBLE9BQUEsQ0FBUSxrQkFBUjs7QUFDQSxPQUFBLENBQVEseUJBQVI7O0FBQ0EsT0FBQSxDQUFRLHVCQUFSOztBQUVBLFVBQUEsR0FBYSxPQUFBLENBQVEsZUFBUjs7QUFDYixlQUFBLEdBQWtCLENBQUMsT0FBQSxDQUFRLDJCQUFSLENBQUQsQ0FBcUMsQ0FBQzs7QUFDeEQsZUFBQSxDQUFnQixVQUFoQjs7QUFFQSxFQUFBLEdBQUssT0FBQSxDQUFRLGtCQUFSOztBQUNMLFFBQUEsR0FBVyxPQUFBLENBQVEsaUJBQVI7O0FBQ1gsT0FBQSxHQUFVLE9BQUEsQ0FBUSxnQkFBUjs7QUFDVixNQUFBLEdBQVMsT0FBQSxDQUFRLGVBQVI7O0FBQ1QsV0FBQSxHQUFjLE9BQUEsQ0FBUSxvQkFBUjs7QUFDZCxPQUFBLEdBQVUsT0FBQSxDQUFRLGdCQUFSOztBQUVWLElBQU8sQ0FBQyxNQUFBLENBQU8sUUFBUCxDQUFELENBQWlCLENBQUMsTUFBbEIsS0FBNEIsQ0FBbkM7RUFDSSxFQUFFLENBQUMsV0FBSCxDQUFBO0VBQ0EsSUFBRyxDQUFDLE1BQUEsQ0FBTyxtQkFBUCxDQUFELENBQTRCLENBQUMsTUFBN0IsS0FBdUMsQ0FBMUM7SUFDSSxRQUFRLENBQUMsV0FBVCxDQUFBLEVBREo7O0VBRUEsSUFBRyxDQUFDLE1BQUEsQ0FBTyxhQUFQLENBQUQsQ0FBc0IsQ0FBQyxNQUF2QixLQUFpQyxDQUFwQztJQUNJLE9BQU8sQ0FBQyxXQUFSLENBQUEsRUFESjs7RUFFQSxJQUFHLENBQUMsTUFBQSxDQUFPLG9CQUFQLENBQUQsQ0FBNkIsQ0FBQyxNQUE5QixLQUF3QyxDQUEzQztJQUNJLE1BQU0sQ0FBQyxlQUFQLENBQXVCLG9CQUF2QixFQURKOztFQUVBLElBQUcsQ0FBQyxNQUFBLENBQU8sZ0JBQVAsQ0FBRCxDQUF5QixDQUFDLE1BQTFCLEtBQW9DLENBQXZDO0lBQ0ksV0FBVyxDQUFDLFdBQVosQ0FBQSxFQURKOztFQUVBLElBQUcsQ0FBQyxNQUFBLENBQU8sY0FBUCxDQUFELENBQXVCLENBQUMsTUFBeEIsS0FBa0MsQ0FBckM7SUFDSSxPQUFPLENBQUMsV0FBUixDQUFBLEVBREo7R0FWSiJ9
